import React from 'react';
import { Button, Modal } from 'antd';

/**
 * Modal for selecting and inserting new components into a screen.
 */
const AddComponentModal = ({
  visible,
  onClose,
  categories,
  onAddComponent,
  activeScreen,
}) => (
  <Modal
    title="Add Content"
    open={visible}
    onCancel={onClose}
    footer={null}
    width={600}
  >
    <div className="space-y-4">
      {Object.entries(categories).map(([key, category]) => (
        <div key={key}>
          <h3 className="text-sm font-semibold text-gray-700 mb-2">{category.label}</h3>
          <div className="grid grid-cols-2 gap-3">
            {category.components.map((comp) => (
              <Button
                key={comp.type}
                type="text"
                className="flex h-auto items-center justify-between rounded-lg border border-[#d8fdd2] bg-[#f6fbf3] px-4 py-3 text-left transition hover:border-[#d8fdd2] hover:bg-white"
                onClick={() => onAddComponent?.(activeScreen, comp.type)}
              >
                <div className="flex items-center gap-3">
                  <span className="flex h-10 w-10 items-center justify-center rounded-full bg-[#d8fdd2] text-sm font-semibold text-gray-700">
                    {comp.icon}
                  </span>
                  <span className="text-sm font-medium text-gray-700">{comp.label}</span>
                </div>
                <span className="text-xs font-semibold text-gray-700">Add</span>
              </Button>
            ))}
          </div>
        </div>
      ))}
    </div>
  </Modal>
);

export default AddComponentModal;
